import {
  BUTTON_SUBMISSION, MY_ACCOUNT_SETTINGS, STASH, OVERLAY
} from '../constants';

export const projectOrders = () => {

  const PROJECT_EXPORT_SUCCESS_SUMMARY_ALL = 'projects: export purchase history: all purchases: export summary';
  const PROJECT_EXPORT_SUCCESS_DETAILS_ALL = 'projects: export purchase history: all purchases: export details';
  const PROJECT_EXPORT_SUCCESS_DETAILS_SINGLE = 'projects: export purchase history: line item: export details';

  // 1.1.72 Download Project Purchases (Export Purchase History) Overlay
  LIFE_CYCLE_EVENT_BUS.on('project-orders.exportPurchaseOverlay', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'projects: project details: export purchase history',
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 1.1.72.1 Successful Purchase History Export
  LIFE_CYCLE_EVENT_BUS.on('project-orders.exportPurchaseSuccess', (data) => {
    const { exportType, exportScope } = data?.output || {};
    const multiExportSettings = exportType === 'SummaryData' ? PROJECT_EXPORT_SUCCESS_SUMMARY_ALL : PROJECT_EXPORT_SUCCESS_DETAILS_ALL;
    const settings = exportScope === 'single' ? PROJECT_EXPORT_SUCCESS_DETAILS_SINGLE : multiExportSettings;
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: settings
      }
    };
    digitalData.event.push(ddoEvent);
  });
};
